import { ChatMessage } from 'src/services/interfaces/ChatMessage.interface';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface ChatStore {
  messages: ChatMessage[];
  sessionId: string;
  suggestedQuestions: string[];
  setMessages: (messages: ChatMessage[]) => void;
  setSessionId: (sessionId: string) => void;
  setSuggestedQuestions: (suggestedQuestions: string[]) => void;
}

export const useChatStore = create<ChatStore>()(
  persist(
    (set) => ({
      messages: [],
      sessionId: '',
      suggestedQuestions: [],
      setMessages: (messages: ChatMessage[]) => set({ messages }),
      setSessionId: (sessionId: string) => set({ sessionId }),
      setSuggestedQuestions: (suggestedQuestions: string[]) =>
        set({ suggestedQuestions }),
    }),
    {
      name: 'chat',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
